export interface Recipe {
  id: string
  translationKey: string
  image: string
  category: string
  servings: number
  difficulty: 'easy' | 'medium' | 'hard'
  time: string
  featured?: boolean
}

export const recipesData: Recipe[] = [
  {
    id: 'amatriciana',
    translationKey: 'amatriciana',
    image: '/images/amatriciana_guanciale.png',
    category: 'Primi',
    servings: 4,
    difficulty: 'medium',
    time: '30 min',
    featured: true,
  },
  {
    id: 'lasagne',
    translationKey: 'lasagne',
    image: '/images/lasagne_mortadella.jpg',
    category: 'Primi',
    servings: 6,
    difficulty: 'medium',
    time: '60 min',
  },
  {
    id: 'spianata',
    translationKey: 'spianata',
    image: '/images/spianata_piccante.jpg',
    category: 'Antipasti',
    servings: 4,
    difficulty: 'easy',
    time: '15 min',
  },
  {
    id: 'pizza-bianca',
    translationKey: 'pizzaBianca',
    image: '/images/Ricette_652X732-Mortadella.jpg',
    category: 'Pizza',
    servings: 4,
    difficulty: 'medium',
    time: '45 min',
  },
  {
    id: 'carbonara',
    translationKey: 'carbonara',
    image: '/images/Ricette_652X732-Guanciale.jpg',
    category: 'Primi',
    servings: 4,
    difficulty: 'medium',
    time: '25 min',
  },
  {
    id: 'crostini',
    translationKey: 'crostini',
    image: '/images/Ricette_652X732-Fiordicotto.jpg',
    category: 'Antipasti',
    servings: 4,
    difficulty: 'easy',
    time: '15 min',
  },
  {
    id: 'crostini-mortadella',
    translationKey: 'crostini-mortadella',
    image: '/images/Ricette_652X732-Mortadella.jpg',
    category: 'Antipasti',
    servings: 4,
    difficulty: 'easy',
    time: '15 min',
  },
  {
    id: 'pasta-prosciutto',
    translationKey: 'pasta-prosciutto',
    image: '/images/categoria_primi-piatti.jpg',
    category: 'Primi',
    servings: 4,
    difficulty: 'easy',
    time: '20 min',
  },
  {
    id: 'insalata-prosciutto',
    translationKey: 'insalata-prosciutto',
    image: '/images/categoria_insalate.jpg',
    category: 'Insalate',
    servings: 2,
    difficulty: 'easy',
    time: '10 min',
  },
  {
    id: 'crostini-guanciale',
    translationKey: 'crostini-guanciale',
    image: '/images/Anteprima-Homepage-Guanciale.jpg',
    category: 'Antipasti',
    servings: 4,
    difficulty: 'easy',
    time: '15 min',
  },
  {
    id: 'tagliere-affettati',
    translationKey: 'tagliere-affettati',
    image: '/images/affettati.png',
    category: 'Aperitivo',
    servings: 4,
    difficulty: 'easy',
    time: '10 min',
  },
  {
    id: 'panini-gourmet',
    translationKey: 'panini-gourmet',
    image: '/images/precotti.jpg',
    category: 'Panini',
    servings: 4,
    difficulty: 'easy',
    time: '15 min',
  },
]

export function getRecipeById(id: string): Recipe | undefined {
  return recipesData.find((r) => r.id === id)
}

export function getFeaturedRecipe(): Recipe {
  return recipesData.find((r) => r.featured) || recipesData[0]
}
